<template>
    <main
        class="
            relative flex flex-wrap w-full
            lg:p-4 lg:flex-no-wrap
            xl:p-6 xl:pt-3
            2xl:p-8 2xl:pt-6
        "
    >
        <!-- Mobile -->
        <transition
            enter-active-class="transform transition ease-in-out duration-500"
            enter-class="-translate-x-full"
            enter-to-class="translate-x-0"
            leave-active-class="transform transition ease-in-out duration-500"
            leave-class="translate-x-0"
            leave-to-class="-translate-x-full"
        >
            <conversation-list class="absolute inset-y-0 w-screen flex p-4 | lg:hidden" v-if="conversationListIsOpen" />
        </transition>
        <transition
            enter-active-class="transform transition ease-in-out duration-500"
            enter-class="translate-x-full"
            enter-to-class="translate-x-0"
            leave-active-class="transform transition ease-in-out duration-500"
            leave-class="translate-x-0"
            leave-to-class="translate-x-full"
        >
            <conversation-message-list class="w-full flex p-4 | lg:hidden" v-if="!conversationListIsOpen" />
        </transition>

        <!-- Desktop -->
        <conversation-list
            class="
                hidden w-full
                lg:flex lg:max-w-sm
                xl:w-2/5
                2xl:max-w-md
            "
        />
        <conversation-message-list
            class="
                hidden w-full
                lg:pl-4 lg:w-auto lg:flex-1 lg:flex lg:p-0
                xl:pl-6
                2xl:pl-8
            "
        />
    </main>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import ConversationList from '@/views/Chat/ConversationList.vue';
    import ConversationMessageList from '@/views/Chat/ConversationMessageList.vue';

    export default {
        components: {
            ConversationList,
            ConversationMessageList,
        },

        data() {
            return {
                conversationListIsOpen: true,
            };
        },

        computed: {
            ...mapState([
                'authUser',
            ]),

            ...mapState('chat', [
                'selectedConversationId',
                'conversations',
                'selectedContactId',
                'userRelatedId',
            ]),
        },

        watch: {
            '$route.params.id'(newValue) {
                if (this.$route.name != 'chat') {
                    return;
                }

                this.setSelectedConversation(newValue);
            },

            'authUser.account.id'() {
                this.conversationListIsOpen = true;
            },

            conversations() {
                if (this.selectedConversationId) {
                    return;
                }

                this.setConversation();
            },
        },

        methods: {
            ...mapActions('chat', [
                'getSelectedConversationFromRelated',
                'setSelectedConversation',
            ]),

            async setConversation() {
                if (!this.conversations.length) {
                    return;
                }

                let conversationId = null;

                if (this.selectedContactId) {
                    const conversation = await this.getSelectedConversationFromRelated({
                        selectedContactId: this.selectedContactId,
                        userRelatedId: this.userRelatedId,
                    });

                    conversationId = conversation?.id;
                } else if (this.$route.params.id) {
                    conversationId = this.$route.params.id;
                } else if (this.selectedConversationId) {
                    conversationId = this.selectedConversationId;
                }

                this.setSelectedConversation(conversationId);

                this.$router.replace({
                    name: 'chat',
                    params: {
                        id: conversationId,
                    },
                }).catch(() => {});
            },

            openConversationList() {
                this.conversationListIsOpen = true;
            },

            closeConversationList() {
                this.conversationListIsOpen = false;
            },
        },

        created() {
            this.$bus.on('conversationList.open', this.openConversationList);
            this.$bus.on('conversationList.close', this.closeConversationList);
        },

        mounted() {
            this.setConversation();
        },

        beforeDestroy() {
            this.$bus.off('conversationList.open', this.openConversationList);
            this.$bus.off('conversationList.close', this.closeConversationList);
        },
    };
</script>
